import api from "../services/api";
import AWS from "aws-sdk"

const { REACT_APP_IDENTITY_POOL_ID, REACT_APP_BUCKET_NAME, REACT_APP_AWS_REGION } = process.env

const REGION = REACT_APP_AWS_REGION; // e.g., us-east-1
const BUCKET = REACT_APP_BUCKET_NAME;
const IDENTITY_POOL_ID = REACT_APP_IDENTITY_POOL_ID;

AWS.config.update({
    region: REGION,
    credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: IDENTITY_POOL_ID,
    }),
});

const s3 = new AWS.S3({
    apiVersion: '2006-03-01',
    params: { Bucket: BUCKET },
});

// common content
export const updateCommonContent = (data) => {
    return api.put(`admin/common/common_content`, data);
};

export const getCommonContent = (queryParams) => {
    return api.get(`common/common_content${queryParams}`);
};

// FAQ Category
export const createFaqCategory = (data) => {
    return api.post('admin/common/add_faq_category', data);
}

export const updateFaqCategory = (data) => {
    return api.put('admin/common/update_faq_category', data);
}

export const updateFaqCategoryStatus = (data) => {
    return api.put('admin/common/update_faq_category_status', data);
}

export const deleteFaqCategory = (id) => {
    return api.delete('admin/common/delete_faq_category', {
        data: { _id: id }
    });
}

export const getFaqCategory = (queryParams) => {
    return api.get(`admin/common/faq_category_list${queryParams}`);
};

// FAQ Questions
export const createFaqQuestion = (data) => {
    return api.post('admin/common/add_faq_question', data);
}

export const updateFaqQuestion = (data) => {
    return api.put('admin/common/update_faq_question', data);
}

export const updateFaqQuestionStatus = (data) => {
    return api.put('admin/common/update_faq_question_status', data);
}

export const deleteFaqQuestion = (id) => {
    return api.delete('admin/common/delete_faq_question', {
        data: { _id: id }
    });
}

export const getFaqQuestions = (queryParams) => {
    return api.get(`admin/common/faq_question_list${queryParams}`);
};

// UPLOAD FILE
export const uploadFile = async ({file, filePath}) => {
    const params = {
        Bucket: BUCKET,
        Key: `${filePath}/${file.name}`,
        Body: file,
        ContentType: file.type,
    };
    return s3.upload(params).promise();
};